import { Box, Typography, TextField, ButtonGroup, Divider, Button } from '@mui/material';
import { useState, useEffect, useCallback } from 'react';
import useResponsive from '../../hooks/useResponsive';
import useDebounce from '../../hooks/useDebounce';
import Iconify from '../Iconify';
import '../../css/roles/roleFiltration.css';

const RisqueFiltration = ({ filtersEmpty, risquesFilters, setRisquesFilters, totalRisques, risquesFetched, filteredRisquesCount, selectedDisplayMode, setSelectedDisplayMode }) => {

    const isDesktop = useResponsive('up', 'lg');

    const [search, setSearch] = useState(risquesFilters?.debouncedSearch || '');
    const debouncedSearch = useDebounce(search, 1000);

    // Update filters when debounced search changes
    useEffect(() => {
        setRisquesFilters((prev) => ({ ...prev, debouncedSearch: debouncedSearch }));
    }, [debouncedSearch, setRisquesFilters]);

    const handleGridMode = useCallback(() => {
        setSelectedDisplayMode('grid');
    }, [setSelectedDisplayMode]);

    const handleListMode = useCallback(() => {
        setSelectedDisplayMode('list');
    }, [setSelectedDisplayMode]);

    return (
        <Box className='rolesFiltration_counts'>
            <Box className='rolesFiltration_wrapper'>
                <Box className='rolesFiltration_container'>

                    <TextField
                        size="small"
                        value={search}
                        placeholder='Rechercher'
                        onChange={(e) => setSearch(e.target.value)}
                        variant="outlined"
                        className='rolesFiltration_search_Box'
                        InputProps={{
                            startAdornment: <Iconify icon={"bx:bx-search"} className='rolesFiltration_search_icon' />,
                            sx: {
                                backgroundColor: '#fff',
                                height: '36px',
                                fontFamily: 'Mulish',
                                color: '#201E1E',
                                fontSize: '14px',
                                fontWeight: 400,
                            },
                        }}
                    />

                    {isDesktop && <Divider orientation="vertical" variant="middle" flexItem />}

                    <ButtonGroup variant="outlined">
                        <Button
                            className={selectedDisplayMode === 'grid' ? 'sites_Filtration_options_selected_button' : 'sites_Filtration_options_button'}
                            onClick={handleGridMode}
                        >
                            <Iconify icon={"gg:menu-grid-r"} />
                        </Button>
                        <Button
                            className={selectedDisplayMode === 'list' ? 'sites_Filtration_options_selected_button' : 'sites_Filtration_options_button'}
                            onClick={handleListMode}
                        >
                            <Iconify icon={"ph:list"} />
                        </Button>
                    </ButtonGroup>

                </Box>

            </Box>

            <Typography className='rolesFiltration_total_number'>
                {risquesFetched} affichés
                {!filtersEmpty && ` / ${filteredRisquesCount} filtrés`}
                {` / ${totalRisques} au total`}
            </Typography>

        </Box>
    );
};

export default RisqueFiltration;